import {CompanyProfile} from "../ProfileStore.tsx";

export type DatabagConfiguration = {
    databag_id: number
    columns: ColumnConfiguration[]
}

export type ColumnConfiguration = {
    table_name: string
    column_name: string
    stat_count: number
    stat_unique: number
    stat_empty: number
    stat_null: number
    stat_is_number: number
    stat_min: string
    stat_max: string

    display_name: string
    description: string
    in_use: boolean
    default_visibility: boolean
    default_order: number | null
    width: number | null
    min_width: number | null
    max_width: number | null
}

type Value = number | string | boolean | object;

export type CustomerConfigurationKeys =
    'LOCALE'
    | 'CURRENCY'
    | 'DATA_YEAR_START'
    | 'DISABLE_PPV'
    | 'DISABLE_GINI'
    | 'TEST_REVIEW_PAGE'
    | 'CATEGORIZATION_SCORE'
    | 'CATEGORIZATION_FILE_DL'
    | 'ADV_DASH_GRAPHS'

export type CustomerConfiguration = {
    key: CustomerConfigurationKeys
    value: Value | Value[] | { [key: string]: Value | Value[] }
}
export type CustomerConfigurationMap = Map<CustomerConfigurationKeys, CustomerConfiguration>;

export type ProfileKeyMapType = {
    [key in CustomerConfigurationKeys]?: {
        pKey: keyof CompanyProfile,
        default: any,
        operation?: (value: any) => any,
    }
}

/**
 * TODO [CAT-3252]: Once FE is migrates we can phase this out
 */
export const ProfileKeyMap: ProfileKeyMapType = {
    'CATEGORIZATION_SCORE': {pKey: 'categorizationShowScore', default: true,},
    'CATEGORIZATION_FILE_DL': {pKey: 'categorizationShowFileDownload', default: false,},
}